(function () {
  'use strict';

  angular
    .module('virtualFairs')
    .controller('VirtualFairCyberSessionDetailController', VirtualFairCyberSessionDetailController)

    VirtualFairCyberSessionDetailController.$inject = ['$uibModalInstance', 'cyberSession'];

  function VirtualFairCyberSessionDetailController($uibModalInstance, cyberSession) {
    var vm = this;

    vm.cyberSession = cyberSession;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.errors = false;

    vm.logicOptions = [
      {id: 0, name: 'No'},
      {id: 1, name: 'Yes'}
    ];

    activate();

    function activate() {
    }

    function ok () {
      $uibModalInstance.close();
    }

    function cancel () {
      $uibModalInstance.close();
    }
  }

})();